<template>
  <div
    @keydown.esc="closeSetNewPasswordPopup"
    ref="setNewPasswordPopup"
    class="lite-lp-popup lite-lp-popup-login-overlay"
    id="lite-lp-popup-login-overlay"
    tabindex="0"
  >
    <div class="lite-lp-popup-content lite-lp-login-popup">
      <header class="popup-header">
        <a
          class="lite-lp-popup-close"
          id="close-login"
          @click="closeSetNewPasswordPopup"
        ></a>
        <h2 class="lite-lp-popup-title">
          <span>{{ $t("CHANGE_PASSWORD") }}</span>
        </h2>
      </header>
      <div v-if="newPasswordSet" class="lite-lp-popup-success">
        <img src="@/assets/images/check.svg" alt="icon" class="icon" />
        <p class="text">{{ $t("NEW_PASSWORD_SET_SUCCESSFULLY") }}</p>
      </div>
        <form
          v-if="!newPasswordSet"
          class="lite-lp-login-popup-form"
          id="loginForm"
          @submit="save($event)"
          style="margin-top: 20px"
        >
         <span style="margin: auto; font-weight: bold;"> {{ $t("PLEASE_ENTER_NEW_PASSWORD") }}</span>
         <span style="margin: 10px 20px;" v-html="$t('PASSWORD_RULES')"></span>
          <div class="input-wrap" :class="{ error: $v.newPassword.$error }">
            <div class="input-design">
              <div class="input-reverse">
                <input
                  :type="showNewPassword ? 'text' : 'password'"
                  class="lite-lp-popup-input password"
                  v-model="newPassword"
                  :placeholder="$t('NEW_PASSWORD')"
                  @input="cleanIsErrorInDetails(), $v.newPassword.$touch()"
                />
                <span @click="showNewPassword = !showNewPassword">
                  <img v-if="!showNewPassword" class="show-password-eye" src="@/assets/images/eye_show_password.svg" alt="icon">
                  <img v-else class="show-password-eye" src="@/assets/images/eye_show_password_hide.svg" alt="icon">
                </span>
              </div>
            </div>
            <span class="error-text">
              <span class="error-text" v-if="$v.newPassword.$error">
                {{ $t(passwordErrorText) }}
              </span>
            </span>
          </div>
          <div class="input-wrap" :class="{ error: $v.repeatNewPassword.$error }">
            <div class="input-design">
              <div class="input-reverse">
                <input
                  :type= "showRepeatPassword ? 'text' : 'password'"
                  class="lite-lp-popup-input password"
                  v-model="repeatNewPassword"
                  :placeholder="$t('REPEAT_NEW_PASSWORD')"
                  @input="cleanIsErrorInDetails(), $v.repeatNewPassword.$touch()"
                />
                <span @click="showRepeatPassword = !showRepeatPassword">
                  <img v-if="!showRepeatPassword" class="show-password-eye" src="@/assets/images/eye_show_password.svg" alt="icon">
                  <img v-else class="show-password-eye" src="@/assets/images/eye_show_password_hide.svg" alt="icon">
                </span>
              </div>
            </div>
            <span class="error-text" v-if="!this.$v.repeatNewPassword.required">
              {{ $t("PASSWORD_MISSING") }}
            </span>
            <span class="error-text" v-if="this.$v.repeatNewPassword.required && !this.$v.repeatNewPassword.matchsNewPassword">
              {{ $t("PASSWORDS_NOT_SAME") }}
            </span>
          </div>
          <button
            type="submit"
            class="lite-lp-popup-submit login"
            :disabled="
              !$v.newPassword.required || $v.newPassword.$error ||
              !$v.repeatNewPassword.required || $v.repeatNewPassword.$error
            "
          >
            {{ $t("SAVE") }}
          </button>
        </form>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'set-new-password',
  components: {},
  data: function () {
    return {
      newPassword: null,
      repeatNewPassword: null,
      showNewPassword: false,
      showRepeatPassword: false,
      isErrorInDetails: false,
      newPasswordSet: false
    }
  },
  validations: {
    oldPassword: {
      required
    },
    newPassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(16),
      containsUppercase: function (value) {
        return /[A-Z]/.test(value)
      },
      containsLowercase: function (value) {
        return /[a-z]/.test(value)
      },
      containsNumber: function (value) {
        return /[0-9]/.test(value)
      },
      isOnlyEnglishLetters: function (value) {
        return /^[\x20-\x7E]*$/.test(value)
      }
    },
    repeatNewPassword: {
      required,
      matchsNewPassword: function () {
        return (this.repeatNewPassword === this.newPassword)
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.base.lang.localName,
      originOfClient: state => state.base.originOfClient
    }),
    passwordErrorText () {
      if (!this.$v.newPassword.required) {
        return ('PASSWORD_MISSING')
      } else if (!this.$v.newPassword.isOnlyEnglishLetters) {
        return ('PASSWORD_LETTERS_MUST_BE_IN_ENGLISH_ONLY')
      } else if (!this.$v.newPassword.minLength || !this.$v.newPassword.maxLength) {
        return ('PASSWORD_MUST_BE_BETWEEN_8_AND_16_CHARACTERS_LONG')
      } else if (!this.$v.newPassword.containsLowercase) {
        return ('PASSWORD_MUST_CONTAIN_LOWERCASE_LETTER')
      } else if (!this.$v.newPassword.containsUppercase) {
        return ('PASSWORD_MUST_CONTAIN_UPPERCASE_LETTER')
      } else if (!this.$v.newPassword.containsNumber) {
        return ('PASSWORD_MUST_CONTAIN_NUMBER')
      }
      return (null)
    }

  },

  methods: {
    cleanIsErrorInDetails () {
      if (this.isErrorInDetails) { this.isErrorInDetails = false }
    },
    closeSetNewPasswordPopup () {
      this.$router.push({ name: 'logIn' })
    },
    save (e) {
      e.preventDefault()
      this.$store.dispatch('changePasswordOfUser', { newPassword: this.newPassword, repeatNewPassword: this.repeatNewPassword, uid: this.$route.params.uid, token: this.$route.params.token }
      // calls function in store to send new password to user, if users data is good sends back true. else sends back false. currently gets true
      ).then((response) => {
        const data = response.data
        if (data.detail) { // if reset password success
          this.newPasswordSet = true
          setTimeout(() => {
          // timeout added so user can see message that new password was sent to users Email
            this.$router.push({ name: 'homePage' })
          }, 5000)
        } else {
          this.isErrorInDetails = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
    .input-wrap .input-design{
      .input-icon{
        background-image: url("../assets/images/logo_classe_grey.svg");
        background-repeat: no-repeat;
      }
      &:focus, &:hover, &:active, &:focus-within{
        .input-icon{background-image: url("../assets/images/logo_classe_blue.svg");}
      }
    }
    .lite-lp-login-popup-form .input-wrap{
      margin: 24px;
    }
    .lite-lp-popup-input{
      margin-right: 10px;
    }
    .show-password-eye{
      width: 23px;
      cursor: pointer;
    }
    .lite-lp-popup-submit {
      width: 78%;
      margin: auto;
    }
    .lite-lp-popup-success .text {
    font-size: 24px;
    font-weight: 700;
    margin-top: 10px;
    text-align: center;
    }
</style>
